import { FC } from "react";
import styled from "styled-components";

import { Td } from "@/components/Table";
import { AmazonProductResource } from "@/types/resources";
import ProductThumbnail from "./ProductThumbnail";
import Text from "@/components/Text";
import { Checkbox, CheckboxHolder, CheckboxLabel } from "./ProductsTable";

const LinkTd = styled(Td)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface Props {
  product: AmazonProductResource;
  selectedProducts: number[];
  setSelectedProducts: React.Dispatch<React.SetStateAction<number[]>>;
}

const ProductsTableRow: FC<Props> = ({
  product,
  selectedProducts,
  setSelectedProducts,
}) => {
  return (
    <>
      <tr>
        <Td>
          <CheckboxHolder>
            <Checkbox
              id={`product-${product.id}`}
              name="products"
              type="checkbox"
              checked={selectedProducts.includes(product.id)}
              onChange={() => {
                selectedProducts.includes(product.id)
                  ? setSelectedProducts((prev) =>
                      prev.filter((item) => item !== product.id)
                    )
                  : setSelectedProducts((prev) => [...prev, product.id]);
              }}
            />
            <CheckboxLabel htmlFor={`product-${product.id}`} />
          </CheckboxHolder>
        </Td>
        <Td>
          <ProductThumbnail
            productId={product.id}
            thumbnail={product.image_url}
            asin={product.asin}
          />
        </Td>
        <LinkTd>
          <Text
            as="a"
            target="blank"
            $type="smallBold"
            rel="nofollow"
            href={`https://amazon.com/${product.link}`}
          >
            {product.name}
          </Text>
        </LinkTd>
        <Td>{product.description ?? "-"}</Td>
        <Td>{product.rating ?? "-"}</Td>
        <Td>{product.reviews_count ?? "-"}</Td>
        <Td>{product.price_strikethrough.toFixed(2)} $</Td>
        <Td>{product.price.toFixed(2)} $</Td>
        <Td>
          {product.discount ? <>{product.discount.toFixed(2)} %</> : "0 %"}
        </Td>
        <Td>{product.prime ? "Yes" : "No"}</Td>
        <Td>{product.is_amazon_choice ? "Yes" : "No"}</Td>
        <Td>{product.best_seller ? "Yes" : "No"}</Td>
      </tr>
    </>
  );
};

export default ProductsTableRow;
